import { useRouter } from "next/router";
import { OG_IMAGE_SITE_URL } from "~/lib/constants";
import { getCurrentDate } from "~/lib/utils/dateHelper";
import { getCurrentProjectId } from "~/lib/utils/urlHelper";
import { Topic } from "~/models/topic";
import { pagesPath } from "faqSrc/lib/$path";

interface Props {
  topicId?: Topic["id"];
}

export const pageOgImage = ({ topicId }: Props): string => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const router = useRouter();
  const pathname = router?.pathname;
  const currentDate = getCurrentDate();
  const defaultOgImage = `${OG_IMAGE_SITE_URL}/api/kikushiru/og_image/site?project_id=${getCurrentProjectId()}&v=${currentDate}`;

  switch (pathname) {
    case pagesPath.qa._topicSlug("").$url().pathname:
      if (!topicId) {
        return defaultOgImage;
      }

      // og-image only works in production
      return `${OG_IMAGE_SITE_URL}/api/kikushiru/og_image/topic?topic_id=${topicId}&v=${currentDate}`;
    case pagesPath.qa._topicSlug("")._questionAnswerId("").$url().pathname:
      if (!router?.query?.questionAnswerId) {
        return defaultOgImage;
      }

      // og-image only works in production
      return `${OG_IMAGE_SITE_URL}/api/kikushiru/og_image/question?question_answer_id=${router.query.questionAnswerId}&v=${currentDate}`;
    default:
      return defaultOgImage;
  }
};

export const pageOgImageHeight = (): string => {
  return "630";
};

export const pageOgImageWidth = (): string => {
  return "1200";
};
